import moment from "moment";
import { capitalizeString, getCityNameByCode } from "../shared/util";

export class EntityAdapter {
  private value: any;

  constructor(input: any) {
    this.value = input;
  }

  get contact_name() {
    return capitalizeString(this.value.contact_name || "");
  }

  get contact_email() {
    return this.value.contact_email || "";
  }

  get update_date() {
    return moment(this.value.update_date).format("YYYY-MM-DD");
  }

  get created_at() {
    return moment(this.value.created_at).format("YYYY-MM-DD");
  }

  get updated_at() {
    return moment(this.value.updated_at).format("YYYY-MM-DD");
  }

  get issue_date() {
    return moment(this.value.issue_date).format("YYYY-MM-DD");
  }

  get current_date() {
    return this.value.current_date
      ? moment(this.value.current_date).format("YYYY-MM-DD")
      : "";
  }

  get city() {
    if (!this.value.city) {
      return this.value.cityRaw || "No Informa";
    }
    return getCityNameByCode(this.value.city)?.municipio || "No definido";
  }

  get state() {
    if (!this.value.state) {
      return this.value.stateRaw || "No Informa";
    }
    return getCityNameByCode(this.value.city)?.departamento || "No definido";
  }

  get recognized_min() {
    return this.value.recognized_min === "1" ? "Si" : "No";
  }

  adapt() {
    return {
      id: this.value.id,
      nit: this.value.nit || "",
      social_reason: capitalizeString(this.value.social_reason || ""),
      description: this.value.description || "",
      phone: this.value.phone || "",
      external_code: this.value.external_code || "",
      features: this.value.features || [],
      url: this.value.url || "",
      city: capitalizeString(this.city || ""),
      state: capitalizeString(this.state || ""),
      contact_name: this.contact_name,
      contact_email: this.contact_email,
      update_date: this.update_date,
      created_at: this.created_at,
      updated_at: this.updated_at,
      issue_date: this.issue_date,
      current_date: this.current_date,
      source: this.value.source || "",
      actor_type: this.value.actor_type || 0,
      recognized_min: this.recognized_min,
      ciiu: this.value.ciiu || [],
      searchers: this.value.searchers || [],
      products: this.value.products || [],
    };
  }
}
